import type { AgreementResponse } from '../types';

export enum RequiredActions {
  CREDENTIAL_RESET = 'CREDENTIAL_RESET',
}

export type InitRequest = {
  browserFingerprint: string;
  browserTimezoneOffset: string;
};

export type ResolveIdentifierResponse = {
  identifier: string;
  requiredActions: RequiredActions[];
};

export type SignInResult = AgreementResponse & {
  email: string;
  acr?: string;
};

export type FinalizeResponse = {
  url: string;
  success: boolean;
  promptPasswordCreation: boolean;
  asurionId?: string;
  acr?: string;
};
